import * as React from "react";
import type { SVGProps } from "react";
const SvgJobmanagementIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="jobmanagement_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M320 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v79.659h45.44A146.56 146.56 0 0 1 896 439.595a42.667 42.667 0 1 1-85.333 0c0-33.835-27.435-61.27-61.227-61.27H256a85.333 85.333 0 0 0-85.333 85.334V768A85.333 85.333 0 0 0 256 853.333h128.299a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V463.659A170.667 170.667 0 0 1 256 292.992h64v-79.659zm298.667 0A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666v79.659h213.334v-79.659zM486.955 672l62.336-107.947a106.667 106.667 0 0 1 92.373-53.333h124.715a106.667 106.667 0 0 1 92.373 53.333L921.131 672a106.667 106.667 0 0 1 0 106.667l-62.379 107.989a106.667 106.667 0 0 1-92.373 53.333H641.707a106.667 106.667 0 0 1-92.374-53.333L487.04 778.709a106.667 106.667 0 0 1 0-106.666zm73.898 42.667a21.333 21.333 0 0 0 0 21.333l62.336 107.99a21.333 21.333 0 0 0 18.475 10.666h124.715a21.333 21.333 0 0 0 18.474-10.667l62.336-107.946a21.333 21.333 0 0 0 0-21.334l-62.293-108.032a21.333 21.333 0 0 0-18.517-10.666H641.707a21.333 21.333 0 0 0-18.475 10.666l-62.293 107.99zM704 789.333a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM341.333 512A42.667 42.667 0 1 0 256 512v128a42.667 42.667 0 1 0 85.333 0V512z"
    />
  </svg>
);
export default SvgJobmanagementIcon;
